import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationCollection } from '../../models/notification-collection.model';
import { NotificationModel } from '../../models/notification.model';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  @Output() onStaffNotificationClick = new EventEmitter<number[]>();

  markAllAsRead() {
    let list = [
      ...this.todaysNotifications.map((i) => i.notificationId),
      ...this.previousNotifications.map((i) => i.notificationId),
    ];
    this.markListAsRead.emit(list);
  }
  _notifications: NotificationCollection[] = [];
  @Input() get notifications(): NotificationCollection[] {
    return this._notifications;
  }
  @Output() markListAsRead = new EventEmitter<number[]>();
  set notifications(value: NotificationCollection[]) {
    this._notifications = value || [];
    this.processData();
  }
  todaysNotifications: NotificationModel[] = [];
  previousNotifications: NotificationModel[] = [];
  constructor() {}

  ngOnInit(): void {}

  processData() {
    this.todaysNotifications = this.notifications
      .filter((i) => i.isToday)
      .map((i) => i.notifications)
      .flat();
    this.previousNotifications = this.notifications
      .filter((i) => !i.isToday)
      .map((i) => i.notifications)
      .flat();
  }

  isTodaysDate(notificationDate: Date) {
    var today = new Date().toUTCString().slice(0, 10);
    var compare = notificationDate.toUTCString().slice(0, 10);

    if (compare === today) {
      return true;
    }

    return false;
  }
  onStaffNotificationClicked():void{
    this.onStaffNotificationClick.emit();
  }
}
